import React, { useState } from "react";
import styles from './videoCallArea.module.css';
//import Grid from '@mui/material/Grid';
import Grid from '@mui/material/Unstable_Grid2';

function VideoCallArea(props) {
  return (
    <Grid xs={props.show_chat_vca ? 9 : 12} container spacing={0} className={styles.vid_background_grid_container}>
      <Grid xs={6} className={styles.grid_item_div}>
        <div className={`${styles.vid_div} ${styles.left_vid_div}`}>
          <video id={styles.own_video} autoPlay></video>
        </div>
      </Grid>
      <Grid xs={6} className={styles.grid_item_div}>
        <div className={`${styles.vid_div} ${styles.right_vid_div}`}>
          <video id={styles.external_video} autoPlay></video>
        </div>
      </Grid>
    </Grid>
  );
}

export default VideoCallArea;

